export enum TransactionsRoutes {
  CreateOne = 'create-one',
  Search = 'search',
  UpdateOne = 'update-one',
  DeleteOne = 'delete-one',
}
